import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { WindowToken } from '@app/shared/window.token';

// TODO: Delete this
// Once we are confident permissions are being handled correctly by the API we can remove this
@Injectable({
  providedIn: 'root',
})
export class SkillStandardsGuardService  {
  constructor(
    private authService: AuthService,
    @Inject(WindowToken) private windowRef: Window,
    private router: Router
  ) {}
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return true;
  }
}
